import React from 'react';

const Modal = ({ isOpen, onClose, title, children }) => {
  // If the modal isn't open, don't render anything
  if (!isOpen) return null;

  return (
    <div style={styles.overlay} onClick={onClose}>
      {/* stopPropagation prevents the modal from closing when clicking inside the white box */}
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={styles.header}>
          <h2 style={styles.title}>{title}</h2>
          <button onClick={onClose} style={styles.closeBtn}>&times;</button>
        </div>
        <div style={styles.content}>
          {children}
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10000, // High z-index to sit above ads and cookie banner
  },
  modal: {
    backgroundColor: '#fff',
    padding: '24px',
    borderRadius: '12px',
    maxWidth: '600px',
    width: '90%',
    maxHeight: '80vh',
    overflowY: 'auto',
    position: 'relative',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '15px',
    borderBottom: '1px solid #e2e8f0',
    paddingBottom: '10px',
  },
  title: {
    margin: 0,
    fontSize: '1.25rem',
    color: '#1e293b',
  },
  closeBtn: {
    fontSize: '28px',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    color: '#64748b',
    lineHeight: '1',
  },
  content: {
    lineHeight: '1.6',
    color: '#334155',
  }
};

export default Modal;